// Angular
import { isPlatformBrowser } from '@angular/common';
import { InjectionToken, PLATFORM_ID, Provider } from '@angular/core';

// Local
import { BrowserWindowRef } from '@core/browser-window.util';

export const WINDOW = new InjectionToken<Window>('WindowToken');

export function windowFactory(
  browserWindowRef: BrowserWindowRef,
  platformId: object,
): Window {
  if (isPlatformBrowser(platformId)) {
    return browserWindowRef.nativeWindow;
  }
  return {} as Window;
}

/**
 * Provides {@link WINDOW}: the browser's `window`, or an empty object off the browser platform.
 * The factory needs its `deps`; without them it never sees the browser platform and returns `{}`.
 */
export function provideWindow(): Provider[] {
  return [
    { provide: BrowserWindowRef, useValue: new BrowserWindowRef() },
    {
      provide: WINDOW,
      useFactory: windowFactory,
      deps: [BrowserWindowRef, PLATFORM_ID],
    },
  ];
}
